module.exports = __webpack_public_path__ + "img/ouboli.286e6a98.png";